var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrapper"}},[_c('apexchart',{staticClass:"apexchart",attrs:{"type":"pie","width":_vm.width,"height":_vm.height,"options":_vm.Options,"series":_vm.Series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }